import { convertUserToSegmentUser, convertWholesalerUserToSegmentUser } from './segmentUser'

export const segmentIdentifyCurrentMember = (userData) => {
  const UserId = userData?.ID

  const segmentUserData = convertUserToSegmentUser(userData)

  window?.analytics.identify(UserId, {
    ...segmentUserData,
    UserId,
  })
}

export const segmentIdentifySignup = (userData) => {
  const UserId = userData?.ID

  const segmentUserData = convertWholesalerUserToSegmentUser(userData)

  window?.analytics.identify(UserId, {
    ...segmentUserData,
    UserId,
  })
}
